import { db } from "./db.js";
import { ref } from "vue";

// ==================== CREATE ====================

function addTrademark(firmId, data) {
  const ref = db.collection(`firms/${firmId}/additions/tm-addition/trademarks`).doc(data.serialNumber);
  return ref.set(data);
}

// ==================== READ ====================

async function getTrademarks(firmId) {
  const trademarks = ref([]);
  await db
    .collection(`firms/${firmId}/additions/tm-addition/trademarks`)
    .get()
    .then((querySnapshot) => {
        trademarks.value = querySnapshot.docs.map((doc) => {
        return { id: doc.id, ...doc.data() };
      });
    });
  return trademarks;
}

function streamTrademarks(firmId, onSnap) {
  return db
    .collection(`firms/${firmId}/additions/tm-addition/trademarks`)
    .onSnapshot(onSnap, (error) => { console.log(error); });
}

async function getTrademark(firmId, serialNumber) {
  return db.doc(`firms/${firmId}/additions/tm-addition/trademarks/${serialNumber}`)
    .get()
    .then((trademark) => {
      return trademark.exists ? trademark.data() : null;
    });
}

// ==================== UPDATE ====================

function updateTrademark(firmId, serialNumber, data) {
  return db.doc(`firms/${firmId}/additions/tm-addition/trademarks/${serialNumber}`).update(data);
}

export {
  addTrademark,
  getTrademarks,
  getTrademark,
  streamTrademarks,
  updateTrademark
};
